import { Map } from "immutable";

import {
  flattenCourse,
  transformServerCourseDetails
} from "seneca-common/features/course/utils";

import actionTypes from "../../../action-types";
import Course from "../../../models/state/courses/course/Course";
import { Courses } from "../../../models/state/courses/Courses";

export default function coursesReducer(
  courses: Courses = Map<string, Course>(),
  action: Record<string, any>
) {
  switch (action.type) {
    case actionTypes.RECEIVE_COURSES_DETAILS: {
      const { coursesDetails } = action.payload;
      return courses.withMutations(courses =>
        coursesDetails.reduce((newCourses: any, courseDetails: any) => {
          const course = transformServerCourseDetails(courseDetails);
          return newCourses.set(courseDetails.id, course);
        }, courses)
      );
    }

    case actionTypes.ADD_COURSE:
    case actionTypes.ADD_COURSE_SKELETON: {
      const course = action.payload.course;
      return courses.set(course.id, flattenCourse(course));
    }

    default:
      return courses;
  }
}
